export class Fee {
  constructor(
    key,
    amount,
    currency,
    title,
    type,
    description
  ) {
    this.key = key;
    this.amount = amount;
    this.currency = currency;
    this.title = title;
    this.type = type;
    this.description = description;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Fee(
        input.key,
        +input.amount,
        input.cur,
        input.title,
        input.fee_type,
        input.description
      )
    }

    return new Fee();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Fee.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Fee.fromApiObject(input)];
    }

    return [];
  }
  static mergeFee(fees) {
    var result = fees.filter(item => item.key !== Fee.FEE_LIST_ID.FEE)
    var dutycastFee = fees.find(item => item.key === Fee.FEE_LIST_ID.FEE);
    result.forEach(element => {
      if (element.key === Fee.FEE_LIST_ID.SHIPPING_COST) {
        if (dutycastFee) {
          element.amount += dutycastFee.amount;
        }
      }
      element.description = element.description || (this.FEE_LIST_LABEL[element.key] ? $.i18n(this.FEE_LIST_LABEL[element.key]) : "");
    });
    // result.push(
    //   Fee.fromApiObject({
    //     "key": "smart_payment",
    //     "amount": "150000.0",
    //     "cur": "VND",
    //   })
    // )
    return result;
  }

  static FEE_LIST_ID = {
    PRODUCTS: "products",
    SHIPPING_COST: 'shipping_cost',
    TAX: 'duties_and_taxes_fee',
    FEE: 'dutycast_fee',
    OFFER: 'dutycast_offer',
    VIP: 'vip_checkout',
    SMART: 'smart_payment',
    PROMOTION_FEE_SHIPPING: 'promotion_free_shipping',
    OTHER_FEE: "other_fee",
  }

  static FEE_LIST_LABEL = {
    [this.FEE_LIST_ID.PRODUCTS]: "checkout_noteProduct",
    [this.FEE_LIST_ID.SHIPPING_COST]: 'checkout_noteShipping',
    [this.FEE_LIST_ID.TAX]: 'checkout_noteTax',
    [this.FEE_LIST_ID.OTHER_FEE]: "checkout_noteOtherFee",
  }
}